
import state from './moduleShopState.js'
import mutations from './moduleShopMutations.js'
import actions from './moduleShopActions.js'
import getters from './moduleShopGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
